import { REACT_APP_PUBLIC_DIRECTUS_API } from '@/constants';
import { createDirectus, rest, authentication, withToken, readMe, logout } from '@directus/sdk';



class DirectusAuthStorage {
    get() {
        try {
            const data = localStorage.getItem("directus_auth");
            return data ? JSON.parse(data) : {};
        } catch {
            return {};
        }
    }
    set(data: any) {
        localStorage.setItem("directus_auth", JSON.stringify(data));
    }
}

const storage = new DirectusAuthStorage();

export const directus = createDirectus(
    REACT_APP_PUBLIC_DIRECTUS_API
)
    .with(
        authentication("cookie", {
            autoRefresh: true,
            credentials: "include",
            msRefreshBeforeExpires: 1000 * 60 * 1,
            storage,
        })
    )
    .with(rest({ credentials: "include" }));


export const getCurrentUserId = async () => {
    const authData = localStorage.getItem('directus_auth');
    let accessToken: string | undefined;
    let result;

    if (authData) {
        accessToken = (JSON.parse(authData) || {}).access_token;
    }

    if (accessToken) {
        result = await directus.request(withToken(accessToken, readMe()));
    }

    return result?.id;
};



export const logoutUser = async () => {
    const authData = localStorage.getItem('directus_auth');
    let refreshToken: string | undefined;

    if (authData) {
        refreshToken = (JSON.parse(authData) || {}).refresh_token;
    }

    if (refreshToken) {
        await directus.request(logout(refreshToken, "json"));
    }

    localStorage.removeItem('directus_auth');
};


export const refreshAuthToken = async () => {
    await directus.refresh();



}

export default directus;
